import ModalWrapper from './ModalWrapper';
import ModalHeader from './ModalWrapper/ModalHeader';
import styled from '@emotion/styled';
import Text from './Text';
import Gap from './Gap';
import StyledTextArea from './StyledTextArea';
import Button from './Button';
import { useState } from 'react';
import { submitFeedbackApi } from '~/api';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

interface IFeedbackProps {
  isVisible: boolean;
  handleClose(): void;
}

const Wrapper = styled.div`
  background: var(--white);
  border-radius: 12px;
  padding: 16px;
`;

const Feedback = ({ isVisible, handleClose }: IFeedbackProps) => {
  const [value, setValue] = useState('');
  const location = useLocation();

  async function handleSubmit() {
    if (!value.trim()) {
      toast.error('Please enter some feedback');
    }

    const promise = await submitFeedbackApi({
      feedback: value,
      location: location,
    });
    const response = await apiResponseHandler(promise);

    if (response.type !== ApiResponseEnum.Success) {
      toast.error('An error occurred while submitting your feedback, please try again later');
    } else {
      toast.success('Feedback submitted successfully!');
      handleClose();
    }
  }

  return (
    <ModalWrapper isVisible={isVisible} modalWidth="400px" handleClose={handleClose}>
      <Wrapper className="full-width">
        <ModalHeader handleClose={handleClose} headerJsx="" />

        <Text size="sm" className="bold">
          Feedback
        </Text>
        <Gap t={12} />

        <Text size="xs">
          We value your feedback! Share your thoughts about our product, and we'll carefully review
          them to make improvements.
        </Text>

        <Gap t={24} />

        <StyledTextArea
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}
          placeholder="Add your feedback"
          rows={5}
        />

        <Gap t={24} />

        <div className="align-center">
          <Button className="full-width" variant="secondary" size="md" onClick={handleClose}>
            Cancel
          </Button>

          <Gap l={12} />

          <Button disabled={!value.trim()} className="full-width" size="md" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </Wrapper>
    </ModalWrapper>
  );
};

export default Feedback;
